import React, { createContext, useContext, useState } from 'react';

import { Sprint } from '../types';

interface SprintContextType {
  selectedSprint: Sprint | null;
  setSelectedSprint: (sprint: Sprint | null) => void;
}

const SprintContext = createContext<SprintContextType | undefined>(undefined);

export function SprintProvider({
  children,
}: {
  children: React.ReactNode;
}): JSX.Element {
  const [selectedSprint, setSelectedSprint] = useState<Sprint | null>(null);

  const value = React.useMemo(
    () => ({ selectedSprint, setSelectedSprint }),
    [selectedSprint],
  );

  return (
    <SprintContext.Provider value={value}>{children}</SprintContext.Provider>
  );
}

export function useSprint(): SprintContextType {
  const context = useContext(SprintContext);
  if (context === undefined) {
    throw new Error('useSprint must be used within a SprintProvider');
  }
  return context;
}
